import styled, { css } from "styled-components";
import icons from "icons";

function ShareButton(props: any) {
   const Container = styled.button`
      padding: 0%;
   `;
   const ShareIcon = styled.div`
      width: 20px;
      height: 20px;
      color: #7c7c7c;
      padding: 10px;
      box-sizing: content-box;
      transition-property: opacity;
      transition-duration: 0.3s;
      transition-timing-function: ease-in-out;
      & img {
         width: 100%;
         height: auto;
      }
      &:hover {
         opacity: 0.8;
      }
   `;

   return (
      <Container onClick={props.onClick}>
         <ShareIcon>
            <img src={props.src} alt="" />
         </ShareIcon>
      </Container>
   );
}

export default function Share(props: any) {
   const Container = styled.div<any>`
      display: inline-block;
      position: relative;
      & button {
         border: none;
         outline: none;
         background-color: transparent;
         cursor: pointer;
      }
   `;

   function shareButtonOnClick() {
      if (navigator.share) {
         navigator
            .share({
               //    title: "기록하며 성장하기",
               //    text: "Hello World",
               url: window.location.href,
            })
            .then(() => console.log("공유 성공"))
            .catch((error) => console.log("공유 실패", error));
      }
   }

   return (
      <Container>
         <ShareButton src={icons.iconShare} onClick={shareButtonOnClick} />
      </Container>
   );
}
